/* assets/quick-add-no-sizes.js */
(function () {
  if (window.__qaNoSizesLoaded) return;
  window.__qaNoSizesLoaded = true;

  /* ---------------------------
   * Section handle helpers
   * --------------------------- */
  function handleFromSectionEl(el) {
    const id = el?.id || '';
    const m = id.match(/^shopify-section-(.+)$/);
    return m ? m[1] : null;
  }

  function detectDrawerHandle() {
    const drawerEl =
      document.querySelector('cart-drawer, [is="cart-drawer"], .cart-drawer, #CartDrawer') ||
      document.querySelector('[data-section-type="cart-drawer"]');
    if (!drawerEl) return null;
    const sec = drawerEl.closest?.('[id^="shopify-section-"]');
    return handleFromSectionEl(sec) || 'cart-drawer';
  }

  function detectHeaderHandle() {
    const candidates = [
      '#shopify-section-cart-icon-bubble',
      '#shopify-section-header',
      '#shopify-section-header-group',
      '#shopify-section-group-header'
    ];
    for (const sel of candidates) {
      const el = document.querySelector(sel);
      if (el) return handleFromSectionEl(el) || sel.replace('#shopify-section-', '');
    }
    return null;
  }

  function detectSectionsToRefresh() {
    const set = new Set();
    const d = detectDrawerHandle();
    if (d) set.add(d);
    const h = detectHeaderHandle();
    if (h) set.add(h);
    return Array.from(set);
  }

  /* ---------------------------
   * AJAX helpers
   * --------------------------- */
  function addToCartWithSections(id, qty, handles) {
    const payload = {
      id,
      quantity: qty,
      sections: handles,
      sections_url: window.location.pathname
    };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    }).then(r => {
      if (!r.ok) throw new Error('Add-to-cart failed');
      return r.json();
    });
  }

  function fetchSections(handles) {
    if (!handles || !handles.length) return Promise.resolve({});
    const qs = handles.map(encodeURIComponent).join(',');
    return fetch(`${window.location.pathname}?sections=${qs}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(r => r.json());
  }

  function replaceReturnedSections(sectionsObj) {
    if (!sectionsObj) return;
    Object.entries(sectionsObj).forEach(([handle, html]) => {
      const target = document.getElementById('shopify-section-' + handle);
      if (target && typeof html === 'string') target.innerHTML = html;
    });
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    document.dispatchEvent(new CustomEvent('cart:rendered'));
  }

  /* ---------------------------
   * Cart bubble (quiet) update
   * --------------------------- */
  async function updateCartBubbleCount() {
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      const itemCount = Number(cart?.item_count || 0);

      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(itemCount), timestamp: Date.now() }));

      const bubble = document.querySelector('[ref="cartBubbleCount"]');
      const bubbleContainer = document.querySelector('[ref="cartBubble"]');
      if (bubble) {
        bubble.textContent = itemCount;
        bubble.classList.toggle('hidden', itemCount === 0);
      }
      if (bubbleContainer) {
        bubbleContainer.classList.toggle('visually-hidden', itemCount === 0);
      }
    } catch (err) {
      console.warn('[qa-nosize] updateCartBubbleCount failed', err);
    }
  }

  /* ---------------------------
   * Open drawer helper
   * --------------------------- */
  function openDrawerIfPossible() {
    try { if (window.CartDrawer?.open) return void window.CartDrawer.open(); } catch {}
    const el = document.querySelector('cart-drawer, [is="cart-drawer"], .cart-drawer, #CartDrawer');
    if (!el) {
      const opener =
        document.querySelector('[data-cart-toggle]') ||
        document.querySelector('[data-action="open-cart"], [data-action="open-drawer"][data-drawer="cart"]') ||
        document.querySelector('[aria-controls="CartDrawer"], [data-cart-modal-open], .js-drawer-open-cart]');
      if (opener) opener.click();
      return;
    }
    try { el.open?.(); } catch {}
    el.classList?.add('is-open');
    el.setAttribute?.('open', '');
  }

  /* ---------------------------
   * Click handling (desktop, no sizes)
   * Grab the event EARLY and stop everything else.
   * --------------------------- */

  // Use pointerdown (fires before click) in capture phase
  document.addEventListener('pointerdown', (e) => {
    const overlay = e.target.closest('[data-qa-nosize]');
    if (!overlay) return;
    // prevent card-link / theme interceptors
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    // we’ll handle the add on actual click so keyboard/assistive tech still works
  }, true);

  // Main handler – also in capture phase and with hard stop
  document.addEventListener('click', async (e) => {
    const overlay = e.target.closest('[data-qa-nosize]');
    if (!overlay) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const id = overlay.getAttribute('data-variant-id');
    if (!id) {
      console.warn('[qa-nosize] missing data-variant-id on overlay');
      return;
    }

    if (overlay.dataset.busy === '1' || overlay.classList.contains('is-loading')) return;

    overlay.dataset.busy = '1';
    overlay.classList.add('is-loading');

    const handles = detectSectionsToRefresh();

    try {
      const json = await addToCartWithSections(id, 1, handles);

      if (json.sections && Object.keys(json.sections).length) {
        replaceReturnedSections(json.sections);
      } else {
        const secs = await fetchSections(handles);
        replaceReturnedSections(secs);
      }

      await updateCartBubbleCount();
      requestAnimationFrame(openDrawerIfPossible);
    } catch (err) {
      console.error('[qa-nosize] add error', err);
    } finally {
      overlay.dataset.busy = '0';
      overlay.classList.remove('is-loading');
    }
  }, true); // capture so we always beat the product card link
})();


